module.exports = __webpack_public_path__ + "img/stopwatch.b652b72b.png";